import { DEFAULT_COMPETITION_TYPE } from '@/common/constant/qz';
import { fetch } from '@/common/js/fetch';
import { serverCourseUrl } from "./api";
import parseParams from "@/common/js/util";


/**
 *@description 获取试卷列表
 */
export function getExamList(competitionType=DEFAULT_COMPETITION_TYPE) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/list?competitionType=${competitionType}`)
}

export function getExamRecordList(examId) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/record/list?examId=${examId}`)
}

/**
/**
 * 开始考试（首次进入考试时调用）
 *
 * @param {Object} params - 参数对象
 * @param {number} params.courseExamId - 试卷ID
 * @param {number} params.roundId - 场次ID
 * @returns {Promise} 请求结果
 */
export function startExam(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/start`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    preview: false,
    ...params,
  }, {
    method: 'POST',
  })
}

export function getExamDetail(id) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/query`, {
    userCourseExamRelationInstanceId: id,
    competitionType: DEFAULT_COMPETITION_TYPE,
  })
}

export function answerExamQuestion(data) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/question/answer`, {
    ...data,
  }, {
    method: 'POST',
  })
}

export function submitExam(id) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/submit?userCourseExamRelationInstanceId=${id}`, {}, {
    method: 'POST',
  })
}

/**
 * 获取所有学校列表
 */
export function getSchoolList() {
//   return Promise.resolve({
//     code:200,
//     body:{
//         "schools": [{
//             "id": 1,
//             "schoolName": "实验中学"
//         },{
//             "id": 2,
//             "schoolName": "实现中学"
//         }]
//     }
// })
  return fetch(`${serverCourseUrl}v1/user/course/exam/school/list`)
}


/**
 * 查询所有考试列表
 */
export function getExamRoundList(params) {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "examRounds": [{
  //       "id": 1, // 考试id
  //       "courseExamId": 1, // 试卷id
  //       "competitionType": "",
  //       "level": "",
  //       "roundName": "考试名",
  //       "order": 12, // 权重
  //       "questionCount": 10,
  //       "startTime": 1757368410000, // 开始时间
  //       "releaseResultTime": 1758232410000, // 释放成绩时间
  //       "rule": {
  //           "id": "RULE_MATHS_TALENTS_3",
  //           "costTime": 180,
  //           "startPoint": 0,
  //           "description": "考试时间180分钟，总分100分。总共13道题：第1-7题（选择题）每道题5分，第8-10题（填空题）每道题5分，第11题 10分，第12-13题 20分，答错/不答不得分",
  //           "totalPoint": 100,
  //           "intervals": [
  //               {
  //                   "start": 1,
  //                   "end": 7,
  //                   "score": 5
  //               }
  //           ]
  //       },
  //       // 考试记录对象（已有的数据结构）
  //       "userCourseExamRelationInstance": {
  //           "id": 11111,
  //           "totalPoints": 110,
  //           "status": 1, // 0未提交 1已提交
  //           markStatus:2
  //           // ...
  //       }
  //   }]
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/course/exam/round/list`,{
    ...params,
    competitionType: DEFAULT_COMPETITION_TYPE,
  })
}

/**
 * 检查是否有考试资格
 * @param {Object} params
 * @param {number} params.courseExamId
 * @param {number} params.roundId
 */
export function checkStartExam(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/start/check`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    ...params,
  }, {
    method: 'POST',
  })
}

/*
* @description: 获取考试记录
* **/
export function getExamHistoryList(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/user/round/list`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
      ...parseParams(params),
  })
}

export function getExamInfo(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/round/query`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    ...params,
  })
}